<template>
  <div>
    <div class="alert alert-danger text-center" v-if="error">
      {{ error }}
    </div>

    <table class="table table-striped" v-if="total">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">{{$t("Type")}}</th>
          <th scope="col">{{$t("Date")}}</th>
          <th scope="col">{{$t("Currency N Amount", {num: 1})}}</th>
          <th scope="col">{{$t("Currency")}} 1</th>
          <th scope="col">{{$t("Currency N Amount", {num: 2})}}</th>
          <th scope="col">{{$t("Currency")}} 2</th>
          <th scope="col">{{$t("Value in BGN")}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="transaction in transactions[currentPage]">
          <td>{{ transaction.id }}</td>
          <td>{{$t(transaction.type)}}</td>
          <td>{{ transaction.date }}</td>
          <td class="text-right">{{ transaction.c1Amount }}</td>
          <td>{{ transaction.c1 }}</th>
          <td class="text-right">{{ transaction.c2Amount }}</td>
          <td>{{ transaction.c2 }}</td>
          <td class="text-right">{{ transaction.valueBGN }}</td>
        </tr>
      </tbody>
    </table>

    <div v-if="!total">{{$t("There are no any transactions")}}.</div>

    <b-pagination v-if="total > itemsPerPage" size="md" :total-rows="total" v-model="currentPage" :per-page="itemsPerPage"></b-pagination>

    <loading :loading="loading"></loading>

  </div>
</template>

<script>
export default {
  created() {
    this.loadTransaction(this.portfolioId)
  },
  props: ['portfolioId'],
  data() {
    return {
      loading: false,
      error: null,
      currentPage: 1,
      itemsPerPage: 20,
    }
  },
  computed: {
    transactions() {
      return this.$store.getters.getSPTransactions
    },
    total() {
      return this.$store.getters.getSPTransactionsTotal
    },
  },
  methods: {
    loadTransaction(portfolioId) {
      const params = {
        portfolioId,
        page: this.currentPage,
        itemsPerPage: this.itemsPerPage,
      }

      this.error = null
      this.loading = true

      this.$store.dispatch('loadPortfolioTransactions', params)
        .catch(errMsg => {
          this.error = errMsg
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
  watch: {
    portfolioId(newId) {
      if (newId) {
        this.currentPage = 1
        this.loadTransaction(newId)
      }
    },
    currentPage() {
      this.loadTransaction(this.portfolioId)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-client-app/components/tables/TransactionsTable.vue